<template>
    <div
        v-if="conflicts.length"
        class="conflict-panel"
        data-testid="conflict-panel"
    >
        <div
            v-if="pendingConflicts.length"
            class="conflict-banner"
            data-testid="conflict-banner"
        >
            <i class="pi pi-exclamation-triangle" />
            <span>
                Behind main — {{ pendingConflicts.length }}
                {{
                    pendingConflicts.length === 1
                        ? "entity needs"
                        : "entities need"
                }}
                resolution
            </span>
        </div>

        <div class="conflict-rows">
            <ConflictEntryRow
                v-for="c in conflicts"
                :key="`${c.entity_type}:${c.entity_id}`"
                :thread-id="threadId"
                :conflict="c"
            />
        </div>
    </div>
</template>

<script setup lang="ts">
import { storeToRefs } from "pinia";

import ConflictEntryRow from "@/components/Thread/ConflictEntryRow.vue";
import { useThreadsStore } from "@/stores/threads-store";

defineProps<{
    threadId: string;
}>();

const store = useThreadsStore();
const { conflicts, pendingConflicts } = storeToRefs(store);
</script>

<style scoped>
.conflict-panel {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    margin-bottom: 0.75rem;
}

.conflict-banner {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    padding: 0.5rem 0.75rem;
    background: color-mix(in srgb, var(--p-orange-500) 12%, transparent);
    border: 1px solid color-mix(in srgb, var(--p-orange-500) 35%, transparent);
    color: var(--p-orange-700, #b45309);
    font-size: 0.85rem;
    font-weight: 500;
}

.conflict-rows {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
}
</style>
